import { CameraLocation } from "../enums/CameraLocation";
import { CameraChannelType } from "../enums/CameraChannelType";
import { IMedia } from "./IMedia";

export interface ICameraChannel extends IMedia {
    Id?: number;
    VehicleId?: number;
    ChannelId?: number;
    IsActive?: boolean;
    CameraLocation?: CameraLocation;
    CameraChannelType?: CameraChannelType;

    // ------------------

    visible?: boolean;
}

export interface IVideoStream extends IMedia {
    ChannelId?: number;
    IsActive?: boolean;
    CameraLocation?: CameraLocation;
    CameraChannelType?: CameraChannelType;
    StreamUrl?: string;
    PlaybackSession?: string;

    // -------------

    visible?: boolean;
    focused?: boolean;
    errored?: boolean;
}

export enum UrlRequired {
    LiveStream,
    Historical
}

export enum FtCloudStreamType {
    All,
    Mainstream,
    Substream
}
